/* eslint-disable max-len */
export default {
    text: 'Strona korzysta z plików cookie w celu realizacji usług zgodnie z',
    privacy: 'Polityką prywatności.',
    button: 'OK'
};



// WEBPACK FOOTER //
// ./src/i18n/pl/cookie.js